export const getToken = (name) => localStorage.getItem(name) || '';